module.exports = __webpack_public_path__ + "static/media/2.dc32f242.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/2.JPG
// module id = 462
// module chunks = 0